<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/solutions/cloud">Cloud</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Hybrid Clouds
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Hybrid Cloud</h2>

              <h3 class="title  pt-2"></h3>
              <p class="lead">
               Our company offers solutions and services to help our clients create competitive advantages that capitalize on market transitions. This enables an organization to be resilient enough to respond to new business needs and user expectations. Rather than a “one size fits all” approach, or having to choose between public or private, we tailor hybrid cloud solutions to meet the unique business requirements presented by every organization.
              </p>
             
            </div>

            <div class="col-lg-4">
              <CloudSideNav></CloudSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import CloudSideNav from "./CloudSideNav";
export default {
  name: "hybrid clouds",
  components: {
    CloudSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>